<template>
<div :class="['micad_formElement micad_formElement_startEndDateCombo',getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <label class="micad_formElement_control_label">Start</label>
        <input type="text" class="micad_formElement_control_input" placeholder="DD/MM/YYYY">
        <label class="micad_formElement_control_label">End</label>
        <input type="text" class="micad_formElement_control_input" placeholder="DD/MM/YYYY">
    </div>
    <div class="micad_formElement_message">{{message}}</div>
</div>
</template>

<script>
export default {
  name: 'Start-end-date-combo',
  data() {
    return {
        label: "Quisque tristique.",
        message: "Quisque tristique quis leo vitae luctus.",
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
              return ' micad_formElement_'+type
            }
        }
    }
};
</script>
